import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {SyncActionModel} from "../../../commons/models/sync-action.model";
import {TasksService} from "../../../tasks/services/tasks-service.service";

export class DeliveryHistoryTableCtrl implements IController {
  service: any;

  public actions: SyncActionModel[];

  /* @ngInject */
  constructor(private tasksService: TasksService) {
  }

  $onInit() {
    if (this.service) {
      const tasksIds = _.flatMap(this.service.taskList, 'id');
      this.tasksService.getOfflineActions(tasksIds)
        .then((actions: any) => {
          this.actions = actions;
        })
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceOfflineActionsView', {
    bindings: {
      service: '<'
    },
    template: require('./service-offline-actions-view.html').default,
    controller: DeliveryHistoryTableCtrl
  });
